import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5faf7478&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=ts&"
export * from "./SideBar.vue?vue&type=script&lang=ts&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=5faf7478&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf7478",
  null
  
)

export default component.exports